/**
 * Which pricing model the server is running.
 *
 *   legacy: city → region → region-pair → zone → rate
 *   zone  : destination city → zone → rate
 *
 * Set at login from the API response (config/rates.php on the backend).
 *
 * Under the zone engine, regions take no part in rating at all: there are no
 * region pairs, no direction and nothing to keep symmetric. Leaving the Region
 * screens visible would invite an admin to configure something the pricing
 * engine will never read, so the UI hides them.
 */

export const RATE_ENGINE_ZONE = 'zone';
export const RATE_ENGINE_LEGACY = 'legacy';

export const getRateEngine = () =>
    localStorage.getItem('rate_engine') || RATE_ENGINE_LEGACY;

/**
 * Refresh the cached value from an API response that reports it.
 *
 * The value is written at login, so a session that predates a server-side flip
 * would keep showing the wrong screens until the user logged out. Any endpoint
 * that returns `rate_engine` calls this to self-heal.
 */
export const setRateEngine = (engine) => {
    if (engine && engine !== localStorage.getItem('rate_engine')) {
        localStorage.setItem('rate_engine', engine);
    }
};

export const isZoneEngine = () => getRateEngine() === RATE_ENGINE_ZONE;

/** Regions are only meaningful while the legacy engine is running. */
export const regionsAreUsed = () => !isZoneEngine();
